module.exports = __webpack_public_path__ + "static/media/TommasoSchiratti.6d22a3e4.jpg";